var render = function () {
  var _vm$medicalCertificat;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": "Медицинская справка",
      "append-icon": "mdi-trash-can-outline"
    },
    on: {
      "click:append-outer": _vm.removeMedicalCertificate
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setMedicalCertificate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {}, [_vm._v("Серия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.medicalCertificate.series,
      callback: function callback($$v) {
        _vm.$set(_vm.medicalCertificate, "series", $$v);
      },
      expression: "medicalCertificate.series"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setMedicalCertificate
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {}, [_vm._v("Номер")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.medicalCertificate.number,
      callback: function callback($$v) {
        _vm.$set(_vm.medicalCertificate, "number", $$v);
      },
      expression: "medicalCertificate.number"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл документа медицинской справки",
      "ref-id": (_vm$medicalCertificat = _vm.medicalCertificate) === null || _vm$medicalCertificat === void 0 ? void 0 : _vm$medicalCertificat.id,
      "ref-class-name": "MedicalCertificate"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }